import { all } from 'redux-saga/effects';
import postalOperatorsWatcher from './PostalOperatorsSaga';

function* postalOperatorsSaga() {
  yield all([
    postalOperatorsWatcher(),
  ]);
}

export default postalOperatorsSaga;
